export const getThePercentage = (number: number, from: number) => (number / from) * 100;

export const formatPercentage = (percentage: number) => `${percentage.toFixed(2)}%`;
